import { WebCrud } from '../../../containers/crud/webCrud';
import { Crud } from '../../../containers/crud/crud';
import { formatDate } from '@arivaa-react/helpers/date-util';
import { useFeatureAccess } from '../../../hooks/useFeatureAccess';

export default function Payment() {
  const { hasAccess } = useFeatureAccess();
  const isAccessAllowed = hasAccess(['admin']);
  return (
    <WebCrud api="payment">
      <Crud.Header title="Payments">
        <Crud.Header.Actions.Common />
      </Crud.Header>
      <Crud.Table
        actions={[]}
        columns={[
          {
            title: 'Payment Id',
            dataIndex: 'paymentId',
          },
          {
            title: 'Date',
            dataIndex: 'createdAt',
            render: (createdAt) => {
              return <p>{formatDate(createdAt)}</p>;
            },
          },
          isAccessAllowed && {
            title: 'User Email',
            dataIndex: 'email',
          },
          {
            title: 'Website',
            dataIndex: 'websiteId',
            render: (websiteName) => {
              return <p>{websiteName ? websiteName : 'Deleted Website'}</p>;
            },
          },
        ].filter(Boolean)}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          {isAccessAllowed && (
            <Crud.Search
              fields={[
                {
                  type: 'text',
                  name: 'email',
                  inputProps: {
                    placeholder: 'User Email',
                  },
                },
              ]}
            />
          )}
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
